import { DialogActions, DialogContent, styled, Typography } from "@mui/material";
import TextConfirmButton from "../AppButtons/TextConfirmButton";
import { StyleguideSavioColors, StyleguideSavioFonts } from "../../configuration/themeSettings";

export const DialogContentStyled = styled(DialogContent, {
    label: "Common-Dialog_DialogContentStyled",
})(({ theme }) => ({
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: "20px !important",
    minWidth: 200
    
}));

export const StyledDialogActions = styled(DialogActions, {
    label: "Common-Dialog_StyledDialogActions",
})(({ theme: Theme }) => ({
    paddingLeft: 13,
    paddingRight: 13,
    minHeight:45
}));

export const TextConfirmButtonStyled = styled(TextConfirmButton, { label: "Common-Dialog_dialog-TextConfirmButtonStyled" })(({ theme }) => ({
    width: "auto",
    minWidth: "163px",
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'inline-block',
    height: 35,
    minHeight: 35,
}));

export const TypographyStyled = styled(Typography, { label: "Common-Dialog_TypographyStyled" })(({ theme }) => ({
   color: StyleguideSavioColors.text.black,
   marginBottom: 20,
  
   fontSize:14,
}));

export const TypographyStyled2 = styled(Typography, { label: "Common-Dialog_TypographyStyled2" })(({ theme }) => ({
    color: StyleguideSavioColors.text.black,
    marginBottom: 20,
   
    fontSize:14,

    '+ div':{
        
        fontSize: 14,
    }
 }));

export const TypographySubTitle = styled(Typography, { label: "Common-Dialog_TypographySubTitle" })(({ theme }) => ({
    color: StyleguideSavioColors.mainBlue,
    marginBottom: 10,
    fontSize: 14,
    fontWeight: StyleguideSavioFonts.bold,
    textTransform: 'uppercase',
 }));
